import {DefaultTheme} from 'styled-components'

const theme: DefaultTheme = {
    fontFamily: 'Poppins',
    palette: {
        common: {
            black: '#222831',
            white: '#ffffff',
            gray: {
                800: '#1a1a1a',
                700: '#333333',
                600: '#666666',
                500: '#999999',
                400: '#CCCCCC',
                300: '#d1d1d1',
                200: '#E6E6E6',
                100: '#F1F0F5',
            },
        },
        primary: {
            darkest: '#FF1F40',
            dark: '#FF4763',
            medium: '#ff768a',
            light: '#FFC2CB',
            lightest: '#FFEBEE',
            contrastText: '#FFFFFF',
            gradient: 'linear-gradient(to bottom right, #ff618a, #ff768a, #ff618a)'
        },
        secondary: {
            darkest: '#E4673A',
            dark: '#e87f58',
            medium: '#F0AC93',
            light: '#F5C8B7',
            lightest: '#fae3db',
            contrastText: '#1E1E1E'
        },
        error: {
            medium: 'red',
            contrastText: '#F23D4019'
        }
    }
}

export default theme;